import * as React from 'react';
import { SVGProps } from 'react';

const SvgDownload = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 0c.401 0 .727.326.727.727v8.911l3.607-3.607a.727.727 0 1 1 1.028 1.029l-4.84 4.84a.725.725 0 0 1-1.037.008L3.137 7.06A.727.727 0 1 1 4.165 6.03l3.607 3.607V.728C7.772.325 8.098 0 8.5 0ZM1.712 14.546a.727.727 0 1 0 0 1.454h13.575a.727.727 0 1 0 0-1.454H1.712Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgDownload;
